import { connect } from "react-redux";

import { formSaveAction2 } from "../../../Engine/ActionCreators/FormActionCreators";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";

import { ActionButton } from "./ActionButton";

export interface ActionButtonOwnProps {
    onCheckErrors?: () => void;
}

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    onCloseForm: () => dispatch(formSaveAction2),
    onSaveAndCloseForm: () => dispatch(formSaveAction2),
});

export const ActionButtonContainer = connect(undefined, mapDispatchToProps)(ActionButton);
